import type { ReactElement } from 'react';
import { PageShell } from '../Page';
import type { PageProps } from '../types';
import { EditableBullets, EditableText } from '../../components/Editable';

/** Fallback page for a section type with no dedicated archetype yet. */
export function GenericPage({ section, actions, readOnly }: PageProps): ReactElement {
  return (
    <PageShell section={section} readOnly={readOnly} onTitleSave={(title) => actions.saveTitle(section, title)}>
      <EditableText
        value={section.content.headline}
        field="headline"
        placeholder="Add a headline"
        readOnly={readOnly}
        onSave={(headline) => actions.saveContent(section, { headline })}
      />
      <EditableText
        value={section.content.body}
        field="body"
        placeholder="Add details"
        readOnly={readOnly}
        onSave={(body) => actions.saveContent(section, { body })}
      />
      <EditableBullets
        value={section.content.bullets}
        readOnly={readOnly}
        onSave={(bullets) => actions.saveContent(section, { bullets })}
      />
    </PageShell>
  );
}
